window.IRON_SHAFT_SPECS = {

  // ─── TRUE TEMPER ────────────────────────────────────────────────────────────
  "true-temper-dynamic-gold-tapered-iron-shaft-355t": {
    "launch": "low", "spin": "low",
    "weightMin": 128, "weightMax": 132, "torque": 1.8,
    "speedMin": 95, "speedMax": 116, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-parallel-iron-shaft-370": {
    "launch": "low", "spin": "low",
    "weightMin": 128, "weightMax": 132, "torque": 1.8,
    "speedMin": 95, "speedMax": 116, "tip": "370", "material": "steel", "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-105-iron-steel-shaft-tapered-tip": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 103, "weightMax": 108, "torque": 1.8,
    "speedMin": 85, "speedMax": 106, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-120-iron-steel-shaft": {
    "launch": "low", "spin": "low",
    "weightMin": 118, "weightMax": 125, "torque": 1.7,
    "speedMin": 92, "speedMax": 114, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-steel-shaft": {
    "launch": "low", "spin": "low",
    "weightMin": 128, "weightMax": 132, "torque": 1.6,
    "speedMin": 95, "speedMax": 118, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-onyx-steel-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 120, "weightMax": 130, "torque": 1.7,
    "speedMin": 90, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "true-temper-dynamic-gold-x7-steel-shaft": {
    "launch": "low", "spin": "low",
    "weightMin": 128, "weightMax": 135, "torque": 1.7,
    "speedMin": 100, "speedMax": 120, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "true-temper-xp-95-steel-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 95, "weightMax": 100, "torque": 2.0,
    "speedMin": 80, "speedMax": 98, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "true-temper-tt-lite-xl-tapered-iron-steel-shaft": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 80, "weightMax": 95, "torque": 2.4,
    "speedMin": 75, "speedMax": 95, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "true-temper-multi-step-lite-parallel-iron-steel-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 95, "weightMax": 110, "torque": 2.0,
    "speedMin": 82, "speedMax": 102, "tip": "370", "material": "steel", "confidence": "MED"
  },
  "true-temper-amt-white-steel-shaft": {
    "launch": "low", "spin": "mid-low",
    "weightMin": 110, "weightMax": 130, "torque": 1.8,
    "speedMin": 95, "speedMax": 116, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "true-temper-amt-black-steel-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 95, "weightMax": 115, "torque": 1.9,
    "speedMin": 88, "speedMax": 108, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "true-temper-amt-red-steel-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 115, "weightMax": 125, "torque": 1.8,
    "speedMin": 90, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "true-temper-commercial-grade-iron-steel-shaft-r-s-combo-0-370-parallel-tip": {
    "launch": "mid", "spin": "mid",
    "weightMin": 120, "weightMax": 130, "torque": 1.8,
    "speedMin": 90, "speedMax": 110, "tip": "370", "material": "steel", "confidence": "LOW"
  },
  "true-temper-vector-steel-iron-shaft-0-370-tip": {
    "launch": "mid", "spin": "mid",
    "weightMin": 95, "weightMax": 110, "torque": 2.2,
    "speedMin": 82, "speedMax": 102, "tip": "370", "material": "steel", "confidence": "LOW"
  },

  // ─── KBS ────────────────────────────────────────────────────────────────────
  "kbs-tour-c-taper-taper-tip-steel-shaft": {
    "launch": "low", "spin": "low",
    "weightMin": 113, "weightMax": 130, "torque": 1.7,
    "speedMin": 95, "speedMax": 116, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "kbs-c-taper-lite-shaft": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 105, "weightMax": 115, "torque": 1.9,
    "speedMin": 88, "speedMax": 107, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "kbs-tour-lite-steel-shafts": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 95, "weightMax": 110, "torque": 1.9,
    "speedMin": 85, "speedMax": 107, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "kbs-tour-120-shaft-taper-tip": {
    "launch": "mid", "spin": "mid",
    "weightMin": 118, "weightMax": 125, "torque": 1.7,
    "speedMin": 95, "speedMax": 114, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "kbs-tour-v-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 110, "weightMax": 125, "torque": 1.7,
    "speedMin": 92, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "kbs-tour-105-steel-shaft": {
    "launch": "mid-high", "spin": "high",
    "weightMin": 105, "weightMax": 115, "torque": 1.8,
    "speedMin": 88, "speedMax": 106, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "kbs-tour-taper-lite-shaft-355-tip": {
    "launch": "mid", "spin": "mid",
    "weightMin": 105, "weightMax": 115, "torque": 1.85,
    "speedMin": 88, "speedMax": 107, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "kbs-tour-taper-shaft": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 115, "weightMax": 130, "torque": 1.7,
    "speedMin": 95, "speedMax": 113, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "kbs-560-shaft-tapered-tip": {
    "launch": "high", "spin": "high",
    "weightMin": 55, "weightMax": 65, "torque": 3.6,
    "speedMin": 50, "speedMax": 78, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "kbs-580-shaft-tapered-tip": {
    "launch": "high", "spin": "high",
    "weightMin": 55, "weightMax": 65, "torque": 3.6,
    "speedMin": 50, "speedMax": 78, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "kbs-hi-rev-2-0-wedge-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 110, "weightMax": 130, "torque": 1.7,
    "speedMin": 90, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "kbs-max-graphite-iron-shaft-355-tip": {
    "launch": "high", "spin": "high",
    "weightMin": 45, "weightMax": 85, "torque": 3.4,
    "speedMin": 51, "speedMax": 82, "tip": "355", "material": "graphite", "confidence": "HIGH"
  },
  "kbs-tour-tgi-tour-graphite-iron-shaft": {
    "launch": "low", "spin": "low",
    "weightMin": 60, "weightMax": 110, "torque": 2.0,
    "speedMin": 57, "speedMax": 100, "tip": "370", "material": "graphite", "confidence": "HIGH"
  },
  "kbs-pgi-players-graphite-iron-shaft-0-355-tip": {
    "launch": "mid", "spin": "mid",
    "weightMin": 50, "weightMax": 100, "torque": 2.5,
    "speedMin": 57, "speedMax": 94, "tip": "355", "material": "graphite", "confidence": "HIGH"
  },
  "kbs-max-80-shaft-370-tip": {
    "launch": "high", "spin": "high",
    "weightMin": 45, "weightMax": 85, "torque": 3.4,
    "speedMin": 51, "speedMax": 82, "tip": "370", "material": "steel", "confidence": "HIGH"
  },

  // ─── NIPPON ─────────────────────────────────────────────────────────────────
  "nippon-ns-pro-modus3-tour105": {
    "launch": "mid", "spin": "mid",
    "weightMin": 103, "weightMax": 113, "torque": 1.6,
    "speedMin": 90, "speedMax": 107, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour120": {
    "launch": "mid-low", "spin": "mid",
    "weightMin": 106, "weightMax": 120, "torque": 1.8,
    "speedMin": 95, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour130": {
    "launch": "mid-high", "spin": "low",
    "weightMin": 124, "weightMax": 132, "torque": 1.4,
    "speedMin": 95, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour125": {
    "launch": "mid", "spin": "mid",
    "weightMin": 120, "weightMax": 128, "torque": 1.5,
    "speedMin": 95, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "nippon-n-s-pro-950gh-steel-shaft": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 110, "weightMax": 116, "torque": 1.7,
    "speedMin": 95, "speedMax": 113, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "nippon-n-s-pro-850gh-steel-shaft": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 110, "weightMax": 116, "torque": 1.7,
    "speedMin": 95, "speedMax": 113, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "nippon-n-s-pro-950gh-neo-steel-shaft-355-tapered-tip": {
    "launch": "mid-high", "spin": "mid-high",
    "weightMin": 94, "weightMax": 104, "torque": 1.9,
    "speedMin": 85, "speedMax": 103, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "nippon-n-s-pro-850gh-neo-steel-shaft-355-tapered-tip": {
    "launch": "mid-high", "spin": "mid-high",
    "weightMin": 84, "weightMax": 88, "torque": 2.05,
    "speedMin": 80, "speedMax": 98, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "nippon-n-s-pro-zelos-6-steel-shaft": {
    "launch": "high", "spin": "mid-high",
    "weightMin": 68, "weightMax": 75, "torque": 2.6,
    "speedMin": 60, "speedMax": 84, "tip": "370", "material": "steel", "confidence": "HIGH"
  },
  "nippon-n-s-pro-zelos-7-steel-shaft": {
    "launch": "high", "spin": "mid-high",
    "weightMin": 70, "weightMax": 77, "torque": 2.5,
    "speedMin": 65, "speedMax": 88, "tip": "370", "material": "steel", "confidence": "HIGH"
  },
  "nippon-n-s-pro-zelos-8-steel-shaft": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 80, "weightMax": 87, "torque": 2.4,
    "speedMin": 75, "speedMax": 94, "tip": "370", "material": "steel", "confidence": "MED"
  },
  "nippon-n-s-pro-1050gh-steel-shaft": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 110, "weightMax": 116, "torque": 1.7,
    "speedMin": 95, "speedMax": 113, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "nippon-n-s-pro-1150gh-steel-shaft-tapered-tip": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 110, "weightMax": 116, "torque": 1.7,
    "speedMin": 95, "speedMax": 113, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "nippon-n-s-pro-750gh-neo-steel-shaft-355-tapered-tip": {
    "launch": "high", "spin": "mid-high",
    "weightMin": 74, "weightMax": 78, "torque": 2.35,
    "speedMin": 70, "speedMax": 90, "tip": "355", "material": "steel", "confidence": "HIGH"
  },

  // ─── PROJECT X ──────────────────────────────────────────────────────────────
  "project-x-5-5-taper-tip-steel-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 115, "weightMax": 125, "torque": 1.8,
    "speedMin": 90, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "project-x-lz-steel-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 115, "weightMax": 125, "torque": 1.8,
    "speedMin": 92, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "project-x-io-steel-shaft": {
    "launch": "mid-low", "spin": "mid",
    "weightMin": 110, "weightMax": 120, "torque": 1.8,
    "speedMin": 92, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "project-x-ls-steel-shaft": {
    "launch": "low", "spin": "low",
    "weightMin": 115, "weightMax": 120, "torque": 1.7,
    "speedMin": 95, "speedMax": 114, "tip": "355", "material": "steel", "confidence": "HIGH"
  },
  "project-x-red-steel-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 115, "weightMax": 125, "torque": 1.8,
    "speedMin": 90, "speedMax": 112, "tip": "355", "material": "steel", "confidence": "MED"
  },
  "project-x-catalyst-graphite-iron-shaft-0-370-parallel-tip": {
    "launch": "mid", "spin": "mid",
    "weightMin": 57, "weightMax": 100, "torque": 4.5,
    "speedMin": 75, "speedMax": 107, "tip": "370", "material": "graphite", "confidence": "HIGH"
  },
  "project-x-cypher-shaft-370-tip": {
    "launch": "high", "spin": "high",
    "weightMin": 50, "weightMax": 70, "torque": 4.5,
    "speedMin": 55, "speedMax": 82, "tip": "370", "material": "graphite", "confidence": "MED"
  },

  // ─── AEROTECH ───────────────────────────────────────────────────────────────
  "aerotech-steelfiber-iron-tapered-shaft": {
    "launch": "mid-low", "spin": "low",
    "weightMin": 105, "weightMax": 115, "torque": 2.2,
    "speedMin": 90, "speedMax": 112, "tip": "355", "material": "composite", "confidence": "HIGH"
  },
  "aerotech-steelfiber-iron-shaft": {
    "launch": "mid-low", "spin": "low",
    "weightMin": 105, "weightMax": 115, "torque": 2.2,
    "speedMin": 90, "speedMax": 112, "tip": "370", "material": "composite", "confidence": "HIGH"
  },
  "aerotech-steelfiber-fc90-iron-shaft-tapered-355-tip": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 85, "weightMax": 95, "torque": 2.6,
    "speedMin": 75, "speedMax": 96, "tip": "355", "material": "composite", "confidence": "HIGH"
  },
  "aerotech-steelfiber-fc90-iron-shaft-parallel-370-tip": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 85, "weightMax": 95, "torque": 2.6,
    "speedMin": 75, "speedMax": 96, "tip": "370", "material": "composite", "confidence": "HIGH"
  },
  "aerotech-steelfiber-fc115-iron-shaft-tapered-355-tip": {
    "launch": "mid", "spin": "mid-low",
    "weightMin": 110, "weightMax": 120, "torque": 2.2,
    "speedMin": 90, "speedMax": 110, "tip": "355", "material": "composite", "confidence": "MED"
  },
  "aerotech-steelfiber-fc115-iron-shaft-parallel-370-tip": {
    "launch": "mid", "spin": "mid-low",
    "weightMin": 110, "weightMax": 120, "torque": 2.2,
    "speedMin": 90, "speedMax": 110, "tip": "370", "material": "composite", "confidence": "MED"
  },
  "aerotech-steelfiber-fc70-parallel-iron-shaft-0-370-tip": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 70, "weightMax": 80, "torque": 2.9,
    "speedMin": 68, "speedMax": 90, "tip": "370", "material": "composite", "confidence": "MED"
  },
  "aerotech-steelfiber-fc80-parallel-iron-shaft-0-370-tip": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 78, "weightMax": 86, "torque": 2.7,
    "speedMin": 72, "speedMax": 92, "tip": "370", "material": "composite", "confidence": "MED"
  },

  // ─── MITSUBISHI ─────────────────────────────────────────────────────────────
  "mitsubishi-mmt-taper-iron-shaft-0-355-tip": {
    "launch": "mid", "spin": "mid",
    "weightMin": 55, "weightMax": 125, "torque": 3.0,
    "speedMin": 80, "speedMax": 106, "tip": "355", "material": "graphite", "confidence": "HIGH"
  },
  "mitsubishi-mmt-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 55, "weightMax": 125, "torque": 3.0,
    "speedMin": 80, "speedMax": 106, "tip": "370", "material": "graphite", "confidence": "HIGH"
  },
  "mitsubishi-ot-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 95, "weightMax": 120, "torque": 2.5,
    "speedMin": 85, "speedMax": 108, "tip": "370", "material": "graphite", "confidence": "MED"
  },
  "mitsubishi-vanquish-iron-shaft": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 60, "weightMax": 85, "torque": 3.5,
    "speedMin": 75, "speedMax": 95, "tip": "370", "material": "graphite", "confidence": "MED"
  },
  "new-mitsubishi-c6-black-iron-22-shaft": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 55, "weightMax": 80, "torque": 3.5,
    "speedMin": 70, "speedMax": 95, "tip": "370", "material": "graphite", "confidence": "MED"
  },

  // ─── UST MAMIYA ─────────────────────────────────────────────────────────────
  "ust-recoil-tapered-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 88, "weightMax": 110, "torque": 3.0,
    "speedMin": 80, "speedMax": 102, "tip": "355", "material": "graphite", "confidence": "MED"
  },
  "ust-dart-v-tapered-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 95, "weightMax": 115, "torque": 2.8,
    "speedMin": 85, "speedMax": 105, "tip": "355", "material": "graphite", "confidence": "MED"
  },
  "recoil-dart-iron-shaft-0-370-parallel-tip": {
    "launch": "mid", "spin": "mid",
    "weightMin": 95, "weightMax": 115, "torque": 2.8,
    "speedMin": 85, "speedMax": 105, "tip": "370", "material": "graphite", "confidence": "MED"
  },
  "ust-recoil-dart-esx-iron-shaft": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 60, "weightMax": 80, "torque": 3.5,
    "speedMin": 70, "speedMax": 92, "tip": "370", "material": "graphite", "confidence": "MED"
  },
  "ust-proforce-v2-95-iron-shaft-0-370-tip": {
    "launch": "mid", "spin": "mid",
    "weightMin": 88, "weightMax": 99, "torque": 3.0,
    "speedMin": 80, "speedMax": 98, "tip": "370", "material": "graphite", "confidence": "HIGH"
  },
  "ust-recoil-460-esx-iron-shaft": {
    "launch": "high", "spin": "mid-high",
    "weightMin": 46, "weightMax": 65, "torque": 4.5,
    "speedMin": 55, "speedMax": 80, "tip": "370", "material": "graphite", "confidence": "HIGH"
  },
  "ust-recoil-680-iron-shaft": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 65, "weightMax": 72, "torque": 3.6,
    "speedMin": 70, "speedMax": 90, "tip": "370", "material": "graphite", "confidence": "HIGH"
  },
  "ust-recoil-780-es-smacwrap-iron-shaft-0-370-parallel-tip": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 75, "weightMax": 82, "torque": 3.3,
    "speedMin": 75, "speedMax": 95, "tip": "370", "material": "graphite", "confidence": "HIGH"
  },

  // ─── FUJIKURA ────────────────────────────────────────────────────────────────
  "fujikura-mci-iron-shaft": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 60, "weightMax": 125, "torque": 2.7,
    "speedMin": 80, "speedMax": 105, "tip": "370", "material": "graphite", "confidence": "HIGH"
  },
  "fujikura-vista-pro-iron-shaft": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 55, "weightMax": 80, "torque": 3.5,
    "speedMin": 70, "speedMax": 92, "tip": "370", "material": "graphite", "confidence": "MED"
  },
  "fujikura-pro-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 80, "weightMax": 110, "torque": 3.0,
    "speedMin": 82, "speedMax": 105, "tip": "370", "material": "graphite", "confidence": "MED"
  },
  "fujikura-axiom-iron-shaft": {
    "launch": "low", "spin": "mid-low",
    "weightMin": 75, "weightMax": 125, "torque": 3.0,
    "speedMin": 80, "speedMax": 106, "tip": "370", "material": "graphite", "confidence": "HIGH"
  },
  "fujikura-sakura-40-iron-hybrid-shaft": {
    "launch": "high", "spin": "mid-high",
    "weightMin": 50, "weightMax": 75, "torque": 3.5,
    "speedMin": 55, "speedMax": 85, "tip": "370", "material": "graphite", "confidence": "MED"
  },

  // ─── GRAPHITE DESIGN ─────────────────────────────────────────────────────────
  "graphite-design-tour-ad-95-iron-shaft": {
    "launch": "low", "spin": "low",
    "weightMin": 85, "weightMax": 95, "torque": 2.8,
    "speedMin": 86, "speedMax": 110, "tip": "355", "material": "graphite", "confidence": "HIGH"
  },
  "graphite-design-tour-ad-85-iron-shaft": {
    "launch": "low", "spin": "low",
    "weightMin": 85, "weightMax": 95, "torque": 2.8,
    "speedMin": 86, "speedMax": 110, "tip": "355", "material": "graphite", "confidence": "HIGH"
  },
  "graphite-design-tour-ad-75-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 50, "weightMax": 115, "torque": 3.0,
    "speedMin": 75, "speedMax": 108, "tip": "355", "material": "graphite", "confidence": "HIGH"
  },
  "graphite-design-tour-ad-65-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 50, "weightMax": 115, "torque": 3.0,
    "speedMin": 75, "speedMax": 108, "tip": "355", "material": "graphite", "confidence": "HIGH"
  },
  "graphite-design-tour-ad-55-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 50, "weightMax": 115, "torque": 3.0,
    "speedMin": 75, "speedMax": 108, "tip": "355", "material": "graphite", "confidence": "HIGH"
  },
  "graphite-design-tour-ad-ut-vf-driving-iron-shaft": {
    "launch": "low", "spin": "low",
    "weightMin": 85, "weightMax": 95, "torque": 2.8,
    "speedMin": 86, "speedMax": 110, "tip": "355", "material": "graphite", "confidence": "HIGH"
  },

  // ─── ALDILA ──────────────────────────────────────────────────────────────────
  "new-aldila-nv-23-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 95, "weightMax": 115, "torque": 2.5,
    "speedMin": 82, "speedMax": 105, "tip": "370", "material": "graphite", "confidence": "LOW"
  },
  "new-aldila-nv-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 95, "weightMax": 115, "torque": 2.5,
    "speedMin": 82, "speedMax": 105, "tip": "370", "material": "graphite", "confidence": "LOW"
  },

  // ─── APOLLO / FST ────────────────────────────────────────────────────────────
  "apollo-standard-steel-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 115, "weightMax": 130, "torque": 1.9,
    "speedMin": 88, "speedMax": 110, "tip": "370", "material": "steel", "confidence": "LOW"
  },
  "apollo-stepless-steel-iron-shaft-r-s-combo-flex": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 115, "weightMax": 125, "torque": 1.8,
    "speedMin": 92, "speedMax": 112, "tip": "370", "material": "steel", "confidence": "MED"
  },
  "fst-steel-shaft-90-115-125": {
    "launch": "mid", "spin": "mid",
    "weightMin": 90, "weightMax": 125, "torque": 1.9,
    "speedMin": 82, "speedMax": 112, "tip": "370", "material": "steel", "confidence": "LOW"
  },
  "fst-pro-stepless-steel-iron-shaft-115-125": {
    "launch": "mid-low", "spin": "mid-low",
    "weightMin": 115, "weightMax": 125, "torque": 1.8,
    "speedMin": 92, "speedMax": 112, "tip": "370", "material": "steel", "confidence": "MED"
  },

  // ─── GRAFALLOY ───────────────────────────────────────────────────────────────
  "grafalloy-pro-custom-graphite-iron-shaft": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 70, "weightMax": 90, "torque": 3.3,
    "speedMin": 72, "speedMax": 95, "tip": "370", "material": "graphite", "confidence": "LOW"
  },
  "grafalloy-prolaunch-blue-iron-shaft": {
    "launch": "mid-high", "spin": "mid-high",
    "weightMin": 60, "weightMax": 75, "torque": 3.8,
    "speedMin": 68, "speedMax": 90, "tip": "370", "material": "graphite", "confidence": "MED"
  },

  // ─── ALPHA GOLF BRANDED ──────────────────────────────────────────────────────
  "alpha-tour-lite-iron-shaft": {
    "launch": "mid-high", "spin": "mid",
    "weightMin": 95, "weightMax": 110, "torque": 1.9,
    "speedMin": 85, "speedMax": 107, "tip": "370", "material": "graphite", "confidence": "MED"
  },
  "platinum-iron-shaft": {
    "launch": "mid", "spin": "mid",
    "weightMin": 60, "weightMax": 95, "torque": 3.2,
    "speedMin": 75, "speedMax": 98, "tip": "370", "material": "graphite", "confidence": "LOW"
  }

};